import * as React from "react";
import { InstantCollapsible } from "sb-resp-ui";
import { CardType } from "../../../../data";
import { marketColumnsDisplay } from "../../../../constants";
import { ContainerQuery } from "react-container-query";
import { MainHeading, GroupingDropdown, HeadingTitle, ToggleOddsBtn } from "../../components";
import { RenderMarketNames } from "../RenderComponents";
import { renderMbnIcon } from "../EventCard/RenderMethods/renderMbnIcon";
export class MainContent extends React.PureComponent {
    renderGroupingDropdown() {
        return this.props.filterProps && this.props.filterProps.shouldShow &&
            React.createElement(GroupingDropdown, Object.assign({}, this.props.filterProps));
    }
    renderToggleButton() {
        return this.props.toggleOddsBtn && this.props.toggleOddsBtn.shouldShow &&
            React.createElement(ToggleOddsBtn, Object.assign({}, this.props.toggleOddsBtn));
    }
    renderMarketNames(params) {
        return this.props.marketNames.length > 0 &&
            React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params });
    }
    renderHeading(renderChildren, params) {
        return React.createElement(React.Fragment, null,
            React.createElement(MainHeading, { key: `sport-${this.props.id}`, cardType: this.props.cardType },
                React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
                this.renderMarketNames(params),
                this.renderToggleButton(),
                this.renderGroupingDropdown(),
                this.props.mbnTag && renderMbnIcon(this.props.mbnTag)),
            renderChildren && this.props.children);
    }
    renderHeadingWrapper(renderChildren) {
        return this.props.cardType === CardType.Multiview
            ? React.createElement(ContainerQuery, { query: marketColumnsDisplay }, (params) => this.renderHeading(renderChildren, params))
            : this.renderHeading(renderChildren);
    }
    render() {
        return React.createElement("div", { className: "rj-ev-list__content", key: `sport-${this.props.id}-content`, "data-uat": "div-ev-list-content" }, this.props.shouldCollapse
            ? (React.createElement(InstantCollapsible, { key: `collapse-subheading-${this.props.id}`, initiallyExpanded: this.props.shouldExpand, trigger: this.renderHeadingWrapper(false), content: React.createElement(React.Fragment, null, this.props.children) }))
            : this.renderHeadingWrapper(true));
    }
}
//# sourceMappingURL=MainContent.js.map